export const getURLParam = (parameter, url) => {
  if (!url) url = window.location.search
  const urlParams = new URLSearchParams(url)
  return urlParams.get(parameter)
}

export const elementVisible = (elm, threshold, mode) => {
  // the higher the threshold, the more visible the element must be
  // to be considered visible

  threshold = threshold || 0
  mode = mode || 'visible'

  const rect = elm.getBoundingClientRect()
  const viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  )
  const above = rect.bottom - threshold < 0
  const below = rect.top - viewHeight + threshold >= 0

  if (mode === 'above') {
    return above
  } else if (mode === 'below') {
    return below
  } else {
    return !above && !below
  }
}

export const randomInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const shuffle = a => {
  let j, x, i
  i = a.length - 1

  while (i > 0) {
    j = Math.floor(Math.random() * (i + 1))
    x = a[i]
    a[i] = a[j]
    a[j] = x
    i--
  }

  return a
}

export const apiURL = () => {
  return document.body.getAttribute('data-api-base-url')
}

export const setRAFInterval = (callback, interval) => {
  let lastTime = performance.now()

  function loop(currentTime) {
    const delta = currentTime - lastTime

    if (delta >= interval) {
      callback()
      lastTime = currentTime
    }

    requestAnimationFrame(loop)
  }

  requestAnimationFrame(loop)
}

export const delay = ms => {
  return new Promise(resolve => {
    const start = performance.now()

    function step(now) {
      if (now - start >= ms) {
        resolve()
      } else {
        requestAnimationFrame(step)
      }
    }

    requestAnimationFrame(step)
  })
}

export const smoothScrollTo = (
  target,
  container = window,
  axis = 'y',
  duration = 300
) => {
  const start = axis === 'x' ? container.scrollLeft : container.scrollTop
  const change = target - start
  const startTime = performance.now()
  const easeOut = t => t * (2 - t)

  const step = now => {
    const t = Math.min((now - startTime) / duration, 1)
    const value = start + change * easeOut(t)

    if (axis === 'x') container.scrollLeft = value
    else container.scrollTop = value

    if (t < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

export const escapeHTML = value => {
  if (value == null) return ''

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
